export default {
  'promotion-campaign': 'Promotion Campaign',
  'banner-ads': 'Banner Ads',
  'landing-page': 'Landing Page',
  video: 'Video',
  device: {
    pc: 'PC Web (Desktop)',
    mobile: 'Mobile',
    tablet: 'Tablet',
    laptop: 'Laptop',
    'smart-tv': 'Smart TV',
    wearable: 'Wearable Device',
  },
  'get-link': 'Get Link',
  'get-code': 'Get Code',
}
